import '../../styles/App.scss'
import '../../styles/Chat.scss'

import * as React from 'react' 
import { Avatar } from '@material-ui/core'
import images from '../../images';
import { ChatMessage } from '../../types/ChatMessage';


interface Props{
    message:ChatMessage
}


export class ChatClientMessageItem extends React.Component<Props, {}>
{
    constructor(props)
    {
        super(props)
    }

    render()
    {
        return(
            <div className="message sent">
                <div className="talk-bubble tri-right right-top">
                    <div className="talktext">
                        <p>{this.props.message.body}</p>
                    </div>
                </div>
                <Avatar
                src={images.avatar2}
                className="chat-avatar chat-avatar-client"
                />
          </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Chat/ChatClientMessageItem.tsx